import React from 'react';
import jss from 'jss';
import { Tooltip, Fade } from '@material-ui/core';

import theme from 'utils/theme';

const styles = ({ background, color, width }) => ({
    tooltip: {
        background: background,
        borderRadius: '0',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
        color: color,
        fontFamily: 'CircularStd',
        fontSize: '12px',
        lineHeight: '145%',
        maxWidth: width || '200px',
        padding: '8px 16px',
        textAlign: 'left',
    },
    tooltipArrow: {
        marginLeft: '5px',
    },
    arrow: {
        '&::before': {
            backgroundColor: background,
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
        },
    },
});

export default class TooltipComponent extends React.Component {
    render() {
        const { background, color, children, position, width, interactive } = this.props;
        const { classes } = jss.createStyleSheet(styles({ background, color, width })).attach();

        return (
            <Tooltip
                title={this.props.message}
                placement={position}
                classes={{
                    tooltip: classes.tooltip,
                    tooltipArrow: classes.tooltipArrow,
                    arrow: classes.arrow,
                }}
                enterDelay={0}
                leaveDelay={0}
                TransitionComponent={Fade}
                TransitionProps={{ timeout: 0 }}
                arrow
                interactive={interactive}
            >
                <div>{children}</div>
            </Tooltip>
        );
    }
}

TooltipComponent.defaultProps = {
    background: theme.colors.black,
    color: theme.colors.white,
    message: '',
    position: 'top',
};
